import React, { useEffect, useState } from "react";

import { checkAdminAccess, useAdminUserContext, useNavigate, useParams } from "utils";

import { ErrorBoundary, MainPage, Tabs } from "components";

import { Articles } from "pages/admin/content/Articles";
import { Courses } from "pages/admin/content/Courses";
import { News } from "pages/admin/content/News";
import { Popups } from "pages/admin/content/Popups";
import { Suggestions } from "pages/admin/content/Suggestions";

export const Content = () => {
  const { section } = useParams();
  const { user } = useAdminUserContext();

  const [currentSection, setCurrentSection] = useState(false);
  const navigate = useNavigate();

  const tabList = [
    {
      name: "Articles",
      key: "articles",
      component: <Articles />,
    },
    {
      name: "Courses",
      key: "courses",
      component: <Courses />,
    },
    {
      name: "News",
      key: "news",
      component: <News />,
    },
    {
      name: "Popups",
      key: "popups",
      component: <Popups />,
    },
    {
      name: "Suggestions",
      key: "suggestions",
      component: <Suggestions />,
    },
  ];

  const getTabItems = () => {
    const tabs = [];
    tabList.forEach((tab) => {
      if (checkAdminAccess(user.role, `content/${tab.key}`)) {
        tabs.push({
          label: tab.name,
          key: tab.key,
          children: <ErrorBoundary>{tab.component}</ErrorBoundary>,
        });
      } else {
        tabs.push({
          label: tab.name,
          key: tab.key,
          children: <ErrorBoundary>{tab.component}</ErrorBoundary>,
          disabled: true,
        });
      }
    });
    return tabs;
  };

  useEffect(() => {
    setCurrentSection(section);
  }, [section]);

  return (
    <MainPage pageName={"admin"}>
      <Tabs activeKey={currentSection} size="small" onChange={(v) => navigate({ pathname: `/content/${v}` }, { replace: true })} items={getTabItems()} />
    </MainPage>
  );
};
